import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import store from './store';
import router from './router';
import i18n from './plugins/i18n.js';
import axios from 'axios';
import linkify from './directives/linkify';

Vue.directive('linkify', linkify);

import ValidationPlugin from "@/plugins/validation.plugin";
import GoogleAnalyticsEventsHelper from '@/plugins/google-analytics-events-helper';

Vue.config.productionTip = false

Vue.use(ValidationPlugin);
Vue.use(GoogleAnalyticsEventsHelper);

if (process.env.VUE_APP_BASE_URL) {
  axios.defaults.baseURL = process.env.VUE_APP_BASE_URL.trim();
}

// Send the selected UI language with every API call
axios.interceptors.request.use(config => {
  config.headers['x-lang'] = i18n.locale;
  return config;
});

new Vue({
  vuetify,
  store,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
